import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
    return (
        <Typewriter
            options={{
                strings: [
                    "Business Analytics Graduate Student",
                    "Aspiring Software Engineer",
                    "Data Analyst",
                    "Python / Java / SQL",
                    "Strategy & Operations Enthusiast",
                ],
                autoStart: true,
                loop: true,
                deleteSpeed: 50,
            }}
        />
    );
}

export default Type;